// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Zy22b","qr-container":"styles_qr-container__fA-fW"};